(() => {
  'use-strict';

  function initWebform(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      const webformSubmissionForm = element.querySelector('.webform-submission-form');

      if (webformSubmissionForm !== null) {
        webformSubmissionForm.addEventListener('invalid', () => {
          webformSubmissionForm.parentElement.classList.add('-formInvalid');
        }, true);
      }

      setTimeout(() => {
        const dialog = element.closest('.ui-dialog');

        if (dialog !== null) {
          const closeButton = dialog.querySelector('.ui-dialog-titlebar-close');
          const closeLink = element.querySelector('.js-modale-close');

          const clickOutsideHandle = (event) => {
            let targetEl = event.target; // clicked element
            do {
              if (targetEl === dialog) {
                // This is a click inside, does nothing, just return.
                return;
              }
              // Go up the DOM
              targetEl = targetEl.parentNode;
            } while (targetEl);
            // This is a click outside.
            closeButton.click();
          };

          if (closeLink !== null) {
            closeLink.addEventListener('click', () => {
              closeButton.click();
            });
          }
          closeButton.addEventListener('click', () => {
            document.removeEventListener('click', clickOutsideHandle);
          });

          document.addEventListener('click', clickOutsideHandle);
        }
      }, 100);
    });
  }

  Drupal.behaviors.webforms = {
    attach: () => {
      const webform = document.querySelectorAll('.node--type-webform');
      if (webform.length !== 0) {
        initWebform(webform);
      }
    },
  };
})();
